export default {
    /**
     * Datos añadidos a data por el mixin:
     * - cnaGroupTypesOptions: array con tipos de grupos cna
     *
     * @return {Object} Data del mixin
     */
    data() {
        return {
            cnaGroupTypesOptions: []
        };
    },
    methods: {
        /**
         * Load cna group types
         */
        loadCnaGroupTypesOptions() {
            const cnaGroupTypes = this.$t(`interveners.cnae_groups`);
            this.cnaGroupTypesOptions = Object.entries(cnaGroupTypes).map(item => {
                return {
                    key: item[0],
                    name: item[1]
                };
            });
        }
    },

    /**
     * Antes de montar el componente se cargan los tipos de vías en la variable
     * `this.cnaGroupOptions`
     */
    beforeMount() {
        this.loadCnaGroupTypesOptions();
    }
};

